export const oneWeekInHours = 24 * 7;

export const closedStorageKey = 'UPGRADE_EXPIRED_PLAN_NOTIFICATION_CLOSED';
